export default __webpack_public_path__ + "static/media/stomach.025248d8.png";